import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderDisableDownloadMobileModal = () => openPopupHelper({ popupName: popupNames.MOBILE_DISABLE_DOWNLOAD });
